module.exports = __webpack_public_path__ + "static/media/arrow_back_green.7976b2ef.svg";